<template>
<div
  class="add-hot-wrapper"
  @click="itemClick"
>
  <i class="add-icon" />
</div>
</template>

<script>
export default {
  name: 'AddHot',
  methods: {
    itemClick () {
      this.$emit('addClick');
    },
  },
};
</script>

<style lang="less" scoped>
.add-hot-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafbfd;
    border: 1px solid #d8e4f0;
    padding: 0 20px;
    border-radius: 4px;
    margin-right: 16px;
    cursor: pointer;
    .add-icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
        background: url("@{zhijiStaticImagePath}class-spr.png");
        background-position: -297px -1px;
    }
    &:hover{
        cursor: pointer;
        .add-icon{
            background-position: -223px -100px;
        }
    }
}
</style>
